import Skeleton from "@material-ui/lab/Skeleton";
import Modal from "@mui/material/Modal";
import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import "react-multi-carousel/lib/styles.css";
import { useLocation, useParams } from "react-router-dom";
import { ViewWheelRightSideBar } from "../../components";
import Navbar from "../../components/Navbar";
import WheelComponent from "../../components/WheelComponent";
import { useGetAllTags, useGetWheel } from "../../services/queries";
import ContentCard from "./Card";
import styles from "./Modal/index.module.css";

import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";
import { Stack, Typography } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import { isMobile as isMobileDevice } from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";
import { TextView } from "../../components";
import AiWheelProgressBar from "../../components/AiWheelProgressBar";
import Button from "../../components/Button";
import CloneAuthor from "../../components/CloneAuthor";
import IOSSwitch from "../../components/IOSSwitch";
import BusinessBoxPreview from "../../components/NewBusinessBox/BusinessBoxPreview";
import { removePendingWheel } from "../../redux/actions";
import { cloneWheel } from "../../services/api";
import ToastMessage from "../../sharedcomponents/Toast";
import { colors } from "../../utils";
import { ASSETS, TOAST_TYPE } from "../../utils/config";
import { getLoggedInUser } from "../../utils/helpers";
import Mobile from "./Mobile";
import LabelsView from "./Mobile/LabelsView";
import ShareModal from "./ShareModal";
import ViewWheelHeader from "./header";
import "./style.css";

function WheelView() {
  const [isVisible, setIsVisible] = useState(false);
  const [openShare, setOpenShare] = useState(false);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const { wheelId } = useParams();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const emailKey = searchParams.get("key");
  const anonymousKey = searchParams.get("anonymous_key");

  const { data, isLoading } = useGetWheel(wheelId, { emailKey, anonymousKey });

  const { data: tagData, isLoading: tagApiLoading } = useGetAllTags();

  const wheel = data?.data || {};

  const isPrivate = wheel?.user !== getLoggedInUser()?.id && !wheel.is_public;

  const wheelSection = wheel.wheel_section || [];
  const activityWheelArray = wheelSection.length
    ? wheelSection[0]?.activity_wheel
    : [];
  const textBodies = activityWheelArray?.map((item) => item.text_body);

  const [selectedArcs, setselectedArcs] = useState(null);
  const [chartState, setChartState] = useState([]);

  const [topRightCorner, settopRightCorner] = useState(null);
  const [mobileContent, setMobileContent] = useState({});

  const [topLeftCorner, settopLeftCorner] = useState(null);
  // const [bottomLeftCorner, setbottomLeftCorner] = useState(null);
  // const [bottomRightCorner, setbottomRightCorner] = useState(null);
  const [showSegmentInfo, setshowSegmentInfo] = useState(false);
  const [disableSegmentToggle, setdisableSegmentToggle] = useState(true);
  const dispatch = useDispatch();
  const userData = {
    id: wheel?.user_profile?.user_id || 1,
    url:
      wheel?.wheel_image ||
      "https://static.wixstatic.com/media/873c71_7cf29d8fa600414fb56f62fa5aa3522f~mv2.png/v1/fit/w_2500,h_1330,al_c/873c71_7cf29d8fa600414fb56f62fa5aa3522f~mv2.png",
  };

  const { userProfile } = useSelector((state) => state.userProfile);
  const isCloned = wheel?.is_cloned || wheel?.is_copied_from_clone;

  const wheelBackground = data?.data?.wallpaper_image
    ? `url(${data?.data?.wallpaper_image})`
    : wheel?.gradient_color_code
    ? wheel?.gradient_color_code
    : "none";

  function parseHTMLArray(textBodies) {
    const parser = new DOMParser();

    let results = {
      audios: [],
      documents: [],
      images: [],
      urls: [],
      videos: [],
    };

    textBodies.forEach((body) => {
      const doc = parser.parseFromString(body, "text/html");

      // Extract images
      const images = [
        ...doc.querySelectorAll('img:not([src^="static/media"])'),
      ].map((img) => img.src);
      results.images.push(...images);

      //Here i am extracting iframes to differentiate between videos and audios based on data-type attribute
      const iframes = [...doc.querySelectorAll("iframe")];
      iframes.forEach((iframe) => {
        const src = iframe.src;
        if (src.includes("youtube.com/embed")) {
          results.videos.push(src);
        } else {
          const type = iframe.getAttribute("data-type");
          const url = iframe.getAttribute("data-url");
          if (type && url) {
            if (type.includes("video")) {
              results.videos.push(url);
            } else if (type.includes("audio")) {
              results.audios.push(url);
            }
          }
        }
      });
      // Extract links for urls and documents
      const links = [...doc.querySelectorAll("a")];
      links.forEach((link) => {
        const href = link.href;
        const type = link.getAttribute("type");
        if (type === "application/pdf") {
          results.documents.push(href);
        } else if (!href.includes("iyuga-backend.s3.amazonaws.com")) {
          results.urls.push(href);
        }
      });
    });

    return results;
  }

  useEffect(() => {
    if (wheel?.temp_id) {
      dispatch(removePendingWheel(parseInt(wheel?.temp_id)));
    }
  }, [wheel]);

  useEffect(() => {
    const wheelData = data?.data?.wheel_section?.length
      ? data.data.wheel_section[0]?.activity_wheel || []
      : [];

    const wheelUpdatedData = wheelData?.map((obj, index) => ({
      label: "blank",
      value: "1",
      isBlank: false,
      // position: 0,
      ...obj,
    }));

    const wheelUpdatedDataSorted = wheelUpdatedData?.sort(
      (a, b) => a.position - b.position
    );

    setChartState(wheelUpdatedDataSorted);
  }, [data]);

  const onCloseModal = () => {
    const updatedChartData = chartState?.map((data) => {
      data.selected = false;
      return data;
    });

    settopRightCorner(null);
    settopLeftCorner(null);
    // setbottomLeftCorner(null);
    // setbottomRightCorner(null);
    setChartState(updatedChartData);
    setIsVisible(false);
  };

  const onCardClose = (cardData) => {
    const idToRemove = cardData?.id;
    const updatedChartData = chartState?.map((data) => {
      if (data?.id === idToRemove) {
        data.selected = false;
        data.isPinned = false;
      }
      return data;
    });

    if (topRightCorner && topRightCorner?.id == idToRemove) {
      settopRightCorner(null);
    } else if (topLeftCorner && topLeftCorner?.id == idToRemove) {
      settopLeftCorner(null);
    }
    setChartState(updatedChartData);
  };

  const onCardPin = (cardData) => {
    const idToPin = cardData?.id;
    const updatedChartData = chartState?.map((data) => {
      if (data?.id === idToPin) {
        return { ...data, isPinned: true }; // Ensure isPinned key exists and set it to true
      }
      return data;
    });
    if (topRightCorner && topRightCorner?.id == idToPin) {
      settopRightCorner({ ...cardData, isPinned: true });
    } else if (topLeftCorner && topLeftCorner?.id == idToPin) {
      settopLeftCorner({ ...cardData, isPinned: true });
    }

    setChartState(updatedChartData);
  };

  const onCardUnPin = (cardData) => {
    const idToUnpin = cardData?.id;
    const updatedChartData = chartState?.map((data) => {
      if (data?.id === idToUnpin) {
        return { ...data, isPinned: false }; // Ensure isPinned key exists and set it to false
      }
      return data;
    });
    if (
      topRightCorner &&
      topRightCorner?.id == idToUnpin &&
      topRightCorner.isPinned === true
    ) {
      settopRightCorner({ ...cardData, isPinned: false });
    } else if (
      topLeftCorner &&
      topLeftCorner?.id == idToUnpin &&
      topRightCorner.isPinned === true
    ) {
      settopLeftCorner({ ...cardData, isPinned: false });
    }
    setChartState(updatedChartData);
  };

  const closeMobileSegment = () => {
    const updatedChartData = chartState?.map((data) => {
      data.selected = false;
      return data;
    });
    setChartState(updatedChartData);
  };

  //   function sortBySide(arr) {
  //     const sideValues = {
  //         'left': 1,
  //         'right': 2
  //     };

  //     arr.sort((a, b) => {
  //         return sideValues[a.side] - sideValues[b.side];
  //     });

  //     return arr;
  // }

  const onArcSelected = (data) => {
    console.log("Selected Data:", data);

    // Initialize segment info display
    setshowSegmentInfo(true);
    settopRightCorner(data[0] || null);
    settopLeftCorner(data[1] || null);
  };

  const onArcSelectedMobile = (data) => {
    console.log("Selected Data:", data);
    const sortedActivityWheel = wheel?.wheel_section?.[0]?.activity_wheel?.sort(
      (a, b) => a.position - b.position
    );
    const itemIndex = sortedActivityWheel?.findIndex(
      (item) => item?.id === data[0]?.id
    );
    setCurrentMobileSegnmentIndex(itemIndex);

    // setCurrentMobileSegnmentIndex(
    //   wheel?.wheel_section[0]?.activity_wheel?.findIndex(
    //     (item) => item.id === data[0]?.id
    //   )
    // );

    // Initialize segment info display
    setMobileContent(data ?? data[0]);
  };

  const [showLabels, setshowLabels] = useState(true);

  const isRightSegmentClosed = topRightCorner === null;
  const isLeftSegmentClosed = topLeftCorner === null;

  useEffect(() => {
    if (isRightSegmentClosed && isLeftSegmentClosed) {
      setshowSegmentInfo(false);
      setdisableSegmentToggle(true);
    } else {
      setdisableSegmentToggle(false);
    }
  }, [topRightCorner, topLeftCorner]);

  // Consider using 480 or 600 pixels as the breakpoint for mobile devices
  const [isMobile, setIsMobile] = useState(window.innerWidth < 480);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 480);
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Set the initial state based on the current window size

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [showMobileLabels, setShowMobileLabels] = useState(false);
  const [currentMobileSegnmentIndex, setCurrentMobileSegnmentIndex] =
    useState(null);

  // const onClickPrev = () => {
  //   if (currentMobileSegnmentIndex > 0) {
  //     // Check if not the first item
  //     const newIndex = currentMobileSegnmentIndex - 1;
  //     setCurrentMobileSegnmentIndex(newIndex); // Update the index state
  //     setMobileContent([wheel?.wheel_section[0]?.activity_wheel[newIndex]]); // Update the mobileContent state
  //   }
  // };

  // const onClickNext = () => {
  //   if (
  //     currentMobileSegnmentIndex <
  //     wheel?.wheel_section[0]?.activity_wheel.length - 1
  //   ) {
  //     // Check if not the last item
  //     const newIndex = currentMobileSegnmentIndex + 1;
  //     setCurrentMobileSegnmentIndex(newIndex); // Update the index state
  //     setMobileContent([wheel?.wheel_section[0]?.activity_wheel[newIndex]]); // Update the mobileContent state
  //   }
  // };

  const onClickPrev = () => {
    const length = wheel?.wheel_section[0]?.activity_wheel.length;
    const newIndex = (currentMobileSegnmentIndex - 1 + length) % length;
    setCurrentMobileSegnmentIndex(newIndex); // Update the index state
    setMobileContent([wheel?.wheel_section[0]?.activity_wheel[newIndex]]); // Update the mobileContent state
  };

  const onClickNext = () => {
    const length = wheel?.wheel_section[0]?.activity_wheel.length;
    const newIndex = (currentMobileSegnmentIndex + 1) % length;
    setCurrentMobileSegnmentIndex(newIndex); // Update the index state
    setMobileContent([wheel?.wheel_section[0]?.activity_wheel[newIndex]]); // Update the mobileContent state
  };

  useEffect(() => {
    // Assuming mobileContent[0]?.id holds the id of the item you want to mark as selected
    const targetId = mobileContent[0]?.id;

    const updatedChartData = chartState?.map((data) => {
      // Check if the current item's id matches the targetId
      if (data.id === targetId) {
        return { ...data, selected: true }; // If so, set selected to true for this item
      } else {
        return { ...data, selected: false }; // Otherwise, set selected to false
      }
    });

    setChartState(updatedChartData);
  }, [mobileContent]);

  const onClickLabelItem = (content, i) => {
    console.log(i, "INDEX");
    setMobileContent([content]);
    setCurrentMobileSegnmentIndex(i);
  };

  const [openCloneModal, setOpenCloneModal] = useState(false);
  const [cloneId, setCloneId] = useState(null);
  const [message, setMessage] = useState("");
  const handleToastCloseCallback = () => {
    setMessage("");
  };
  const handleCloneWheel = async () => {
    setCloneId(wheel?.id);
    try {
      const response = await cloneWheel(wheel?.id);
      if (response.data.already_cloned) {
        setOpenCloneModal(true);
      } else {
        setMessage("Wheel has been cloned.");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const replaceClone = async () => {
    setOpenCloneModal(false);
    try {
      await cloneWheel(cloneId, {
        action: "overwrite",
      });
      setMessage("Previous clone has been replaced");
      setCloneId(null);
    } catch (err) {
      console.log(err);
    }
  };

  const createNewClone = async () => {
    setOpenCloneModal(false);
    try {
      await cloneWheel(cloneId, {
        action: "new",
      });
      setMessage("New clone has been created");
      setCloneId(null);
    } catch (err) {
      console.log(err);
    }
  };

  console.log(wheel, "wheelwheelwheel");

  var _shareURL =
    window.location.origin +
    "/wheelView/" +
    wheel?.id +
    "/" +
    wheel?.wheel_name?.replace(/\s/g, "");
  if (!isMobileDevice) {
    return (
      <Stack
        sx={{
          height: "100vh",
          position: "relative",
        }}
        direction={"column"}
      >
        <Stack>
          <Navbar />
        </Stack>
        {isLoading ? (
          <div
            style={{
              width: "60%",
              height: "70%",
              backgroundColor: colors.white,
              borderRadius: 20,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "auto",
            }}
          >
            <Skeleton
              variant="rect"
              width={450}
              height={450}
              className="rounded-circle"
            />
          </div>
        ) : !isPrivate ? (
          <>
            <Stack>
              <ViewWheelHeader
                disable={disableSegmentToggle}
                showSegmentInfo={showSegmentInfo}
                setshowSegmentInfo={setshowSegmentInfo}
                handleShare={(flag) => setOpenShare(flag)}
                onInfoClick={() => setshowSegmentInfo(true)}
                onWheelClick={() => setshowSegmentInfo(false)}
                wheelName={wheel.wheel_name}
                authorName={
                  wheel?.user_profile?.first_name +
                    " " +
                    wheel?.user_profile?.last_name ?? ""
                }
                isMyProfile={
                  wheel?.user_profile?.user_id === getLoggedInUser()?.id
                }
                wheelId={wheel?.id}
                isLoading={isLoading}
                authorImage={wheel?.user_profile?.profile_image}
                user_id={wheel?.user_profile?.user_id}
                onCloneClick={handleCloneWheel}
                // onBackClick={}
              />
              {message && (
                <ToastMessage
                  message={message || "Some thing went wrong. Please try again"}
                  type={TOAST_TYPE.SUCCESS}
                  show={true}
                  handleCloseCallback={handleToastCloseCallback}
                />
              )}

              <Modal
                open={openCloneModal}
                onClose={() => setOpenCloneModal(false)}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
              >
                <div className="clone-modal">
                  <TextView variant="subtitle" style={{ textAlign: "center" }}>
                    You've already cloned this Wheel. Would you like to replace
                    your previous Clone or create a new one?
                  </TextView>
                  <div className="clone-button-view">
                    <Button
                      onClick={replaceClone}
                      style={{
                        width: 180,
                        height: 30,
                        fontSize: 12,
                        backgroundColor: colors.background,
                        border: `1px solid ${colors.primary}`,
                        color: colors.darkGrey,
                        marginRight: 10,
                      }}
                    >
                      Replace previous clone
                    </Button>
                    <Button
                      onClick={createNewClone}
                      style={{
                        width: 100,
                        height: 30,
                        fontSize: 12,
                      }}
                    >
                      Create New
                    </Button>
                  </div>
                </div>
              </Modal>
            </Stack>
            <Stack
              sx={{
                flexGrow: 1,
                py: 2,
                backgroundColor: wheel?.primary_color_code,
                backgroundImage: wheelBackground,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
              }}
            >
              <div
                style={{
                  display: "flex",
                  height: "100%",
                }}
              >
                <div
                  style={{ visibility: showSegmentInfo ? "visible" : "hidden" }}
                >
                  <ContentCard
                    position="left"
                    topContent={topLeftCorner}
                    // bottomContent={null}
                    onCardClose={onCardClose}
                    onCardPin={onCardPin}
                    onCardUnPin={onCardUnPin}
                    wheelId={wheel?.id}
                    showEditIcon={
                      userProfile?.user_id === wheel.user_profile?.user_id
                    }
                  />

                  <ContentCard
                    position="right"
                    topContent={topRightCorner}
                    // bottomContent={null}
                    onCardClose={onCardClose}
                    onCardPin={onCardPin}
                    onCardUnPin={onCardUnPin}
                    wheelId={wheel?.id}
                    showEditIcon={
                      userProfile?.user_id === wheel.user_profile?.user_id
                    }
                  />
                </div>
                <div
                  className={styles.left}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "center",
                    visibility: !showSegmentInfo
                      ? "visible"
                      : isLeftSegmentClosed
                      ? "visible"
                      : "hidden",
                  }}
                >
                  {!isLoading && (
                    <Card
                      style={{
                        width: "100%",
                        borderRadius: "20px",
                        // margin
                        marginBottom: "20px",
                        border: 0,
                      }}
                    >
                      <Card.Body>
                        <Card.Text
                          style={{
                            fontSize: "10px",
                            lineHeight: "20px",
                            color: "#565556",
                          }}
                        >
                          {wheel?.description
                            ? wheel?.description
                            : wheel?.user_profile?.bio
                            ? wheel?.user_profile?.bio
                            : ""}
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  )}

                  {wheel.business_box && (
                    <BusinessBoxPreview
                      onlyBusinessBox={true}
                      noBusinessBox={false}
                      businessBoxData={wheel?.business_box}
                      scrollable={true}
                      noEdit
                    />
                  )}
                </div>

                <div
                  className={styles.middle}
                  style={{
                    background: "white",
                    borderRadius: "31px",
                    position: "relative",
                  }}
                >
                  {isLoading ? (
                    <Skeleton
                      variant="rect"
                      width={450}
                      height={450}
                      className="rounded-circle"
                    />
                  ) : (
                    <div onClick={toggleVisibility}>
                      <WheelComponent
                        // config={null}
                        userData={userData}
                        showLabels={showLabels}
                        maxSelectedArcs={2}
                        setChartData={setChartState}
                        onArcSelected={onArcSelected}
                        chartData={chartState}
                      />
                    </div>
                  )}

                  {!isLoading && (
                    <div>
                      <FormControl component="fieldset">
                        <FormGroup aria-label="position">
                          <FormControlLabel
                            style={{ marginTop: 40 }}
                            value="start"
                            control={
                              <IOSSwitch
                                checked={showLabels}
                                onChange={(e) =>
                                  setshowLabels(e.target.checked)
                                }
                                color="primary"
                              />
                            }
                            label={
                              <Typography
                                sx={{
                                  fontFamily: "DM Sans",
                                  fontSize: 14,
                                  lineHeight: "20px",
                                  letterSpacing: "-0.2px",
                                  mr: 2,
                                }}
                              >
                                Show Labels
                              </Typography>
                            }
                            labelPlacement="start"
                          />
                        </FormGroup>
                      </FormControl>
                    </div>
                  )}
                </div>

                <div
                  className={styles.right}
                  style={{
                    visibility: !showSegmentInfo
                      ? "visible"
                      : isRightSegmentClosed
                      ? "visible"
                      : "hidden",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    justifyContent: "right",
                  }}
                >
                  {isCloned ? (
                    <div
                      style={{
                        position: "absolute",
                        right: "1vw",
                        bottom: "3vh",
                      }}
                    >
                      <CloneAuthor
                        wheelId={wheelId}
                        style={{ backgroundColor: "white" }}
                        data={data?.data}
                      />{" "}
                    </div>
                  ) : null}
                  <AiWheelProgressBar />
                  <ViewWheelRightSideBar
                    Links={parseHTMLArray(textBodies)}
                    starred_list={data?.data?.starred_links}
                    normal_list={data?.data?.normal_links}
                  />
                </div>
              </div>
            </Stack>
          </>
        ) : (
          <div
            style={{
              width: "100%",
              height: "100%",
              backgroundColor: colors.background,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "60%",
                height: "90%",
                backgroundColor: colors.white,
                borderRadius: 20,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <img
                src={ASSETS.wheelPrivate}
                alt="pvt"
                style={{
                  width: 240,
                  height: 240,
                  marginBottom: 40,
                }}
              />
              <TextView
                variant="title"
                style={{ width: "40%", textAlign: "center", lineHeight: 1.5 }}
              >
                Sorry, the Wheel URL you're trying to access leads to a Private
                Wheel
              </TextView>
            </div>
          </div>
        )}
        {openShare && (
          <ShareModal
            userData={userData}
            chartState={chartState}
            wheelBackground={wheelBackground}
            wheel={wheel}
            handleClose={() => setOpenShare(false)}
          />
        )}
      </Stack>
    );
  }

  const isMobileSegmentOpen = Object.keys(mobileContent).length !== 0;

  if (isMobileDevice) {
    return (
      <>
        <Mobile
          data={wheel}
          isLoading={isLoading}
          mobileContent={mobileContent}
          showLabels={showMobileLabels}
          onCloseSegment={() => {
            setMobileContent([]);
            closeMobileSegment();
          }}
          handleShowLabels={() => {
            setShowMobileLabels(true);
            setMobileContent([]);
          }}
          onClickBack={() => {
            setShowMobileLabels(false);
            setMobileContent([]);
            closeMobileSegment();
          }}
          onClickNext={onClickNext}
          onClickPrev={onClickPrev}
          currentMobileSegnmentIndex={currentMobileSegnmentIndex}
          disablePrev={currentMobileSegnmentIndex === 0}
          disableNext={
            !isLoading
              ? currentMobileSegnmentIndex ===
                wheel?.wheel_section[0]?.activity_wheel.length - 1
              : false
          }
          wheelChildren={
            showMobileLabels ? (
              <LabelsView
                wheel={wheel}
                onClickLabel={(e, i) => onClickLabelItem(e, i)}
                mobileContent={mobileContent}
                onClickNext={onClickNext}
                onClickPrev={onClickPrev}
                // disablePrev={currentMobileSegnmentIndex === 0}
                // disableNext={
                //   currentMobileSegnmentIndex ===
                //   wheel?.wheel_section[0]?.activity_wheel.length - 1
                // }
                currentMobileSegnmentIndex
              />
            ) : (
              <>
                <WheelComponent
                  containerDivStyle={{
                    width: isMobileSegmentOpen ? "60vw" : "80vw",
                    marginLeft: isMobileSegmentOpen ? "9vw" : "8vw",
                    marginBottom: isMobileSegmentOpen ? "-16vh" : "-9vh",
                    marginTop: isMobileSegmentOpen ? "-17vh" : "-12vh",
                  }}
                  config={{
                    maxArcPerSide: 1,
                    isSmallView: false,
                  }}
                  userData={userData}
                  showLabels={false}
                  maxSelectedArcs={1}
                  setChartData={setChartState}
                  onArcSelected={onArcSelectedMobile}
                  chartData={chartState}
                />
                <Stack
                  display={"flex"}
                  flexDirection={"row"}
                  justifyContent={"flex-end"}
                  alignItems={"center"}
                >
                  <ArrowCircleLeftOutlinedIcon
                    style={{
                      fontSize: "30px",
                      // opacity: disablePrev ? 0.5 : 1
                    }}
                    onClick={onClickPrev}
                  />
                  <ArrowCircleRightOutlinedIcon
                    style={{
                      fontSize: "30px",
                      // opacity: disableNext ? 0.5 : 1
                    }}
                    onClick={onClickNext}
                    // onClick={() => (disableNext ? null : onClickNext())}
                  />
                </Stack>
              </>
            )
          }
        />
      </>
    );
  }
}

export default WheelView;
